module.exports = __webpack_public_path__ + "img/Jordan.97b03ee2.svg";